<template>
    <v-sheet :class="['background-section', {'tile': tile}]">
        <div class="title-light secondary-color">
            {{ title }}
        </div>
        <div class="headline-heavy mt-1" style="width: 80%;">
            {{ subtitle }}
        </div>
    </v-sheet>
</template>

<script>
export default {
    name: "TitleSection",
    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        tile: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>

.background-section {
    background: #273866;
    border-radius: 0 0 10px 10px;
    color: #FFFFFF;
    padding: 15px 30px;
    position: relative;
    z-index: 0;
}

.background-section::before {
    position: absolute;
    content: '';
    right: 10px;
    top: 0;
    background-image: url('~@/assets/logos/logo_cut.png');
    background-size: contain;
    background-position: right;
    height: 100%;
    width: 100%;
    display: inline-block;
    opacity: .5;
    z-index: -1;
}

.tile {
    border-radius: 0;
}

</style>